import React, { Fragment, useState } from 'react';
import { ProductImage } from 'anf-core-react';
import ImagePlaceholder from './ImagePlaceholder';

export default function ImageGalleryGrid({
  productImages,
  onClick,
  handleImageErrorOrRemoval,
  tmntData,
  singleView,
  isMobile,
}) {
  const [isLoading, setIsLoading] = useState(true);

  const handleImageLoad = () => {
    setIsLoading(false);
  };

  const handleImageError = (imageId) => {
    setIsLoading(false);
    handleImageErrorOrRemoval(imageId);
  };

  const noThumbnails = productImages?.length <= 1;

  const containerClassName = noThumbnails
    ? 'product-page-gallery-mfe-container no-thumbnails'
    : 'product-page-gallery-mfe-container';

  return (
    <div className="product-page-gallery-mfe" data-testid="pdp-image-gallery-grid">
      {productImages?.map((img) => (
        <Fragment key={img.imageId}>
          {isLoading && <ImagePlaceholder singleView={singleView} isMobile={isMobile} />}
          <div
            className={containerClassName}
            key={img.imageId}
          >
            <ProductImage
              alt={tmntData?.mainImageAltText?.value.replace('{0}', img.type)}
              classList="product-image-react-gallery"
              src={img.mainImageSrc}
              onClick={(event) => onClick(event, img)}
              onError={() => handleImageError(img.imageId)}
              onLoad={handleImageLoad}
            />
          </div>
        </Fragment>
      ))}
    </div>
  );
}
